import {Multimedia} from '@/types/matrix';
import {Box, Card, CardMedia} from '@mui/material';

import VideoPreviewWithPlayIcon from '@/components/matrix-chat/ui/video-preview-with-play-icon';
interface BoxWithFiveElementsProps {
  urls: string[];
  handleOpenFullScreen: (url: string) => void;
  multimediaType: Multimedia;
}
const BoxWithFiveElements: React.FC<BoxWithFiveElementsProps> = ({
  urls,
  handleOpenFullScreen,
  multimediaType
}) => {
  const cardProps = {
    height: '100%',
    objectFit: 'cover'
  };

  const cardMediaProps = {
    cursor: 'pointer',
    objectFit: 'cover',
    height: '100%'
  };

  const isVideo = multimediaType === 'video';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        //gap: '5px',
        maxWidth: {xs: '150px', md: '300px'},
        maxHeight: {xs: '125px', md: '250px'}
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row'
          //gap: '5px'
        }}
      >
        {urls.slice(0, 2).map((url, index) => (
          <Box
            key={url}
            sx={{
              height: {xs: '75px', md: '150px'},
              width: {xs: '75px', md: '150px'}
            }}
          >
            <Card sx={cardProps}>
              {isVideo ? (
                <VideoPreviewWithPlayIcon
                  url={urls[index]}
                  handleOpenFullScreen={handleOpenFullScreen}
                />
              ) : (
                <CardMedia
                  component="img"
                  image={urls[index]}
                  alt={`${multimediaType} ${index}`}
                  onClick={() => handleOpenFullScreen(urls[index])}
                  sx={cardMediaProps}
                />
              )}
            </Card>
          </Box>
        ))}
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row'
          //gap: '5px'
        }}
      >
        {urls.slice(2, 5).map((url, index) => (
          <Box
            key={url}
            sx={{
              height: {xs: '50px', md: '100px'},
              width: {xs: '50px', md: '100px'}
            }}
          >
            <Card sx={cardProps}>
              {isVideo ? (
                <VideoPreviewWithPlayIcon
                  url={urls[index + 2]}
                  handleOpenFullScreen={handleOpenFullScreen}
                />
              ) : (
                <CardMedia
                  component="img"
                  image={urls[index + 2]}
                  alt={`${multimediaType} ${index + 3}`}
                  onClick={() => handleOpenFullScreen(urls[index + 2])}
                  sx={cardMediaProps}
                />
              )}
            </Card>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default BoxWithFiveElements;
